export interface ToastNotificationProps {
  id?: string
  className?: string
  withTitle?: boolean
  withShadow?: boolean
  withErrorIcon?: boolean
  withCloseIcon?: boolean
  onClose?: any
  titleMessage?: string
  notificationType: NotificationType
  titleTextColor?: string
  backgroundColor?: string
  padding?: string
  crossIconSize?: string
  onMouseEnter?: any
  onMouseLeave?: any
  textAlign?: string
}
export interface NotificationWrapperProps {
  backgroundColor?: string
  padding: string
  shadow?: boolean
  textAlign?: string
}

export enum NotificationType {
  Warning = 'Warning',
  Error = 'Error',
  Success = 'Success',
  Info = 'Info',
  Default = 'Default'
}
